// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8909361a","453":"0c1e82b3","455":"8b716bc3","977":"4f66ca86"}[chunkId] + ".chunk.js";
};